<template>
  <div class="comment-actions" role="group" aria-label="Comment actions">
    <button
      v-if="canReply"
      type="button"
      class="comment-actions__button"
      data-testid="comment-action-reply"
      @click="emit('reply')"
    >
      Reply
    </button>
    <button
      v-if="canResolve"
      type="button"
      class="comment-actions__button"
      data-testid="comment-action-resolve"
      @click="emit('resolve')"
    >
      Resolve
    </button>
    <button
      v-if="isOwn"
      type="button"
      class="comment-actions__button"
      data-testid="comment-action-edit"
      @click="emit('edit')"
    >
      Edit
    </button>
    <button
      v-if="canDelete"
      type="button"
      class="comment-actions__button comment-actions__button--destructive"
      data-testid="comment-action-delete"
      @click="emit('delete')"
    >
      Delete
    </button>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  /** The viewer wrote this comment: unlocks Edit and Delete. */
  isOwn: { type: Boolean, default: false },
  /** Account admins may delete other people's comments. */
  isAdmin: { type: Boolean, default: false },
  canReply: { type: Boolean, default: true },
  /** Resolve applies to the whole thread, so replies hide it. */
  canResolve: { type: Boolean, default: true },
});

const emit = defineEmits(["reply", "resolve", "edit", "delete"]);

const canDelete = computed(() => props.isOwn || props.isAdmin);
</script>

<style scoped>
.comment-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 18px;
}

.comment-actions__button {
  padding: 0;
  border: none;
  background: transparent;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #475467;
  cursor: pointer;
}

.comment-actions__button:hover {
  text-decoration: underline;
}

.comment-actions__button:focus-visible {
  outline: 2px solid #7f56d9;
  outline-offset: 2px;
  border-radius: 2px;
}

.comment-actions__button--destructive {
  color: #b42318;
}
</style>
